import api from './api';
import {
  ShareToggleResponse,
  SharedStudySession,
  SharedExam,
} from '../types/share.types';

export const shareApi = {
  enableStudyShare: (sessionId: number): Promise<ShareToggleResponse> =>
    api.post(`/api/share/study/${sessionId}/enable`).then(res => res.data),
  
  disableStudyShare: (sessionId: number): Promise<ShareToggleResponse> =>
    api.post(`/api/share/study/${sessionId}/disable`).then(res => res.data),

  getSharedStudySession: (token: string): Promise<SharedStudySession> =>
    api.get(`/api/share/study/${token}`).then(res => res.data),

  enableExamShare: (examId: number): Promise<ShareToggleResponse> =>
    api.post(`/api/share/exam/${examId}/enable`).then(res => res.data),

  disableExamShare: (examId: number): Promise<ShareToggleResponse> =>
    api.post(`/api/share/exam/${examId}/disable`).then(res => res.data),

  getSharedExam: (token: string): Promise<SharedExam> =>
    api.get(`/api/share/exam/${token}`).then(res => res.data),
};

export default shareApi;
